import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { signUp } from '../../redux/actions/action-creator';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { dateFormateShow, formatInputToCapitalization, getDateInFormate, statesList } from '../Date_Formate_Utilitiy/Index';
import useClickOutside from '../Custom_Hooks/useClickOutsSide';
import { useFormHandler, prepareFormData } from '../Custom_Hooks/useFormHandler'
import DropdownYesNo from '../Dropdown/DropdownYesNo';
import DropdownLayout_1 from '../Dropdown/DropdownLayout_1';
import { useInputAction } from '../Custom_Hooks/useInputAction';
import InputField from '../Input/InputField';
import TextArea from '../Input/TextArea';
import CreateConfirm from '../Modal/CreateConfirm';
import RegistrationFooter from '../Footer/RegistrationFooter';
import { yes_no_array } from '../Dummi_Data';
import Indicator from '../Indicator/Indicator';

const currentDate = new Date();
const currentMonth = currentDate.getMonth();
const currentYear = currentDate.getFullYear();
const financialYearStartMonth = 3;
const financialYearStartYear = currentMonth < financialYearStartMonth ? currentYear - 1 : currentYear;
const financialYearEndYear = financialYearStartYear + 1;
const date_1 = new Date(`${financialYearStartYear}-${financialYearStartMonth + 1}-01`)
const date_2 = new Date(`${financialYearEndYear}-${financialYearStartMonth}-31`)
const financialYear = `${date_1.getDate()}-${date_1.toLocaleString('default', { month: 'short' })}-${date_1.getFullYear()} To ${date_2.getDate()}-${date_2.toLocaleString('default', { month: 'short' })}-${date_2.getFullYear()}`;
const current_date_redux = `${currentDate.toLocaleString('en-US', { weekday: 'long' })},${currentDate.getDate()}-${currentDate.toLocaleString('default', { month: 'short' })}-${currentDate.getFullYear()}`
let missingFields = [];
const initialState = {
    company_name: '',
    mailing_name: '',
    address: '',
    city: '',
    state: 'Madhya Pradesh',
    country: 'India',
    pincode: '',
    mobile: '',
    telephone: '',
    fax: '',
    email: '',
    website: '',
    financial_year_begning_form: dateFormateShow(date_1),
    books_being_date: dateFormateShow(date_1),
    user_name: 'admin',
    password: "",
    confirm_password: "",
    enable_tally_audit_feature: '',
    maintain_multiple_branches_for_this_company: '',
    base_currancy_symbol: 'Rs',
    formal_name: 'INR',
    suffex_symbol_amount: 'Yes',
    add_space_between_amount_symbol: 'Yes',
    no_of_decimal_place: '2',
    word_reprenting_after_amount: 'Paise',
    no_of_decimal_place_for_amount: '2'
}


const RegistrationPage = (props) => {

    const dispatch = useDispatch();
    const [nameInput, setNameInput] = useState(null)
    const [showStateList, setShowStateList] = useState(false);
    const [drop_add_show, setDrop_add_show] = useState(false)
    const [data, setData] = useState(initialState);

    const inputRefs = {
        company_name: useRef(null),
        mailing_name: useRef(null),
        address: useRef(null),
        city: useRef(null),
        state: useRef(null),
        country: useRef(null),
        pincode: useRef(null),
        mobile: useRef(null),
        telephone: useRef(null),
        fax: useRef(null),
        email: useRef(null),
        website: useRef(null),
        financial_year_begning_form: useRef(null),
        books_being_date: useRef(null),
        user_name: useRef(null),
        password: useRef(null),
        confirm_password: useRef(null),
        // enable_tally_audit_feature: useRef(null),
        base_currancy_symbol: useRef(null),
        formal_name: useRef(null),
        suffex_symbol_amount: useRef(null),
        add_space_between_amount_symbol: useRef(null),
        no_of_decimal_place: useRef(null),
        word_reprenting_after_amount: useRef(null),
        no_of_decimal_place_for_amount: useRef(null),
        registration: useRef(null),
    };
    const first_ref = inputRefs?.company_name

    function getCurrentInputRef(name) {
        return inputRefs[name] || null;
    }


    const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    const validations = {
        company_name: (value) => value.trim() !== "",
        mailing_name: (value) => value.trim() !== "",
        address: (value) => value.trim() !== "",
        city: (value) => value.trim() !== "",
        state: (value) => statesList.some(item => cleanString(item.name).toLowerCase()?.includes(cleanString(value).toLowerCase())),
        pincode: (value) => (/^\d{1,6}$/).test(value),
        mobile: (value) => (/^\d{1,10}$/).test(value),
        telephone: (value) => (/^(\d+)[-]?(\d{3})?[.]?(\d*)$/).test(value),
        fax: (value) => (/^(\d+)[,]?(\d{3})?[.]?(\d*)$/).test(value),
        add_space_between_amount_symbol: (value) => yes_no_array.some(item => cleanString(item.name).toLowerCase()?.includes(cleanString(value).toLowerCase())),
        no_of_decimal_place: (value) => (/^\d+$/).test(value),
        no_of_decimal_place_for_amount: (value) => (/^\d+$/).test(value),

    };

    const refs = Object.keys(inputRefs).reduce((acc, name) => {
        acc[name] = {
            onFocus: () => {
                const ref = getCurrentInputRef(name);
                if (ref) {
                    setNameInput(ref)
                    ref?.current?.setSelectionRange(0, ref?.current?.value?.length)
                };
                if (name === 'state') {
                    setShowStateList(true)
                    console.log('focus')
                }
                if (name === 'add_space_between_amount_symbol') {
                    setDrop_add_show(true)
                }
            },
            onBlur: (value) => {
                if (name === 'company_name') {
                    if (!value.trim()) {
                        getCurrentInputRef(name)?.current?.focus();
                    }
                }
                // if (name === 'company_name' || name === 'state' || name === 'financial_year_begning_form' || name === 'books_being_date' || name === 'user_name' || name === 'password' || name === 'confirm_password') {
                //     if (!value.trim()) {
                //         getCurrentInputRef(name)?.current?.focus();
                //     }
                // }

                // if (name === 'confirm_password') {
                //     if (data?.password !== value) {
                //         getCurrentInputRef(name)?.current?.focus();
                //     }
                // }

                if (name === 'state') {
                    setShowStateList(false)
                }
                // if (name === 'email') {
                //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                //     const isValidEmailFormat = emailRegex.test(value);
                //     if (isValidEmailFormat) {
                //         setData({ ...data, ['email']: value });
                //     } else {
                //         getCurrentInputRef(name)?.current?.focus();
                //     }
                // }
                if (name === 'financial_year_begning_form') {
                    const fyb = getDateInFormate(value)
                    if (fyb) {
                        setData({ ...data, ['financial_year_begning_form']: fyb });
                    } else {
                        getCurrentInputRef(name)?.current?.focus();
                    }
                }
                if (name === 'books_being_date') {
                    const fyb = getDateInFormate(value)
                    if (fyb) {
                        const date_1 = new Date(data.financial_year_begning_form)
                        const date_2 = new Date(fyb)
                        if (date_2 >= date_1) {
                            setData({ ...data, ['books_being_date']: fyb });
                        } else {
                            getCurrentInputRef(name)?.current?.focus();
                        }
                    } else {
                        getCurrentInputRef(name)?.current?.focus();
                    }
                }
                // if (name === 'mobile' && value) {
                //     if (!/^\d{10}$/.test(value)) {
                //         getCurrentInputRef(name)?.current?.focus();
                //     }
                // }
                if (name === 'add_space_between_amount_symbol') {
                    setDrop_add_show(false)
                }
                // if (name === 'website') {
                //     if (value) {
                //         const emailRegex = /^(ftp|http[s]?):\/\/[^ "]+$/;
                //         const isValidEmailFormat = emailRegex.test(value);
                //         if (isValidEmailFormat) {
                //             setData({ ...data, ['website']: value });
                //         } else {
                //             getCurrentInputRef(name)?.current?.focus();
                //         }
                //     }
                // }

            },
        };
        return acc;
    }, {});


    const validateForm = () => {
        const requiredFields = [
            { field: 'company_name', message: 'Required Company Name' },
            { field: 'mailing_name', message: 'Required Mailing Name' },
            { field: 'financial_year_begning_form', message: 'Required Financial Year' },
            { field: 'books_being_date', message: 'Required Book Being Date' },
            { field: 'user_name', message: 'Required User Name' },
            { field: 'password', message: 'Required Password' },
            { field: 'confirm_password', message: 'Required Confirm Password' },
            { field: 'email', message: 'Required Email' },
            { field: 'base_currancy_symbol', message: 'Required Base Currency Symbol' },
            { field: 'formal_name', message: 'Required Formal Name' },
            { field: 'suffex_symbol_amount', message: 'Required Suffex Symbol Amount' },
            { field: 'add_space_between_amount_symbol', message: 'Required Add Space Between Amount Symbol' },
            { field: 'no_of_decimal_place', message: 'Required No of Decimal Place' },
            { field: 'word_reprenting_after_amount', message: 'Required Word Reprenting After Amount' },
            { field: 'no_of_decimal_place_for_amount', message: 'Required No of Decimal Place For Amount' }
        ];

        for (let { field, message } of requiredFields) {
            if (!data?.[field]) {
                toast.error(message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSubmitConfirm('');
                getCurrentInputRef(field)?.current?.focus();
                return false;
            }
        }

        // Specific field validation logic for some fields
        if (data?.books_being_date && data?.financial_year_begning_form) {
            const date_1 = new Date(data.financial_year_begning_form);
            const date_2 = new Date(data.books_being_date);
            if (!(date_2 >= date_1)) {
                toast.error('Book Date Should be equal to fy or Greater', {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSubmitConfirm('');
                getCurrentInputRef('books_being_date')?.current?.focus();
                return false;
            }
        }

        if (data?.password !== data?.confirm_password) {
            toast.error('Confirm Password Not Match', {
                position: toast.POSITION.TOP_CENTER,
            });
            setSubmitConfirm('');
            getCurrentInputRef('confirm_password')?.current?.focus();
            return false;
        }

        if (data?.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValidEmailFormat = emailRegex.test(data?.email);
            if (!isValidEmailFormat) {
                toast.error('Email Invalid', {
                    position: toast.POSITION.TOP_CENTER,
                });
                setSubmitConfirm('');
                getCurrentInputRef('email')?.current?.focus();
                return false;
            }
        }

        return true;
    };

    // Function to reset form fields-----------------------------------------
    const resetForm = () => {
        setData(initialState)
        setSubmitConfirm('')
    };

    const check_dropdown = showStateList || drop_add_show
   
    const { handleChange, handleFocus, handleBlur, handleKeyDown, setSubmitConfirm, submitConfirm, handleDropdownClick } = useInputAction({
        data,
        setData,
        validations,
        refs,
        check_dropdown,
        inputRefs
    });

    const { handleSubmit, loading, handleFocusReset } = useFormHandler({
        validateForm,
        prepareFormData: () => prepareFormData(data),
        submitForm: (data) => dispatch(signUp(data)),
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => handleSubmit(new Event('submit')),
            },
        ],
        resetForm,
        first_ref,
        setSubmitConfirm,
        submitConfirm,
    });


    const inputFields = [
        { label: 'Company Name', name: 'company_name', type: 'text', isRequired: true },
        { label: 'Mailing Name', name: 'mailing_name', type: 'text', isRequired: true },
        { label: 'Address', name: 'address', type: 'text', isRequired: false },
        { label: 'Financial Year Beginning From', name: 'financial_year_begning_form', type: 'text', isRequired: true },
        { label: 'Books Beginning From', name: 'books_being_date', type: 'text', isRequired: true },
        { label: 'Username (Administrator)', name: 'user_name', type: 'text', isRequired: true },
        { label: 'Password', name: 'password', type: 'password', isRequired: true },
        { label: 'Confirm Password', name: 'confirm_password', type: 'password', isRequired: true },
        // { label: 'Enable TallyAudit Features', name: 'enable_tally_audit_feature', type: 'text', value: data?.enable_tally_audit_feature, ref: inputRefs?.enable_tally_audit_feature },
        { label: 'City', name: 'city', type: 'text', isRequired: false },
        { label: 'State', name: 'state', type: 'text', isRequired: false },
        { label: 'Country', name: 'country', type: 'text', isRequired: false },
        { label: 'Pincode', name: 'pincode', type: 'text', isRequired: false },
        { label: 'Mobile', name: 'mobile', type: 'text', isRequired: false },
        { label: 'Telephone', name: 'telephone', type: 'text', isRequired: false },
        { label: 'Fax', name: 'fax', type: 'text', isRequired: false },
        { label: 'E-Mail', name: 'email', type: 'text', isRequired: true },
        { label: 'Website', name: 'website', type: 'text', isRequired: false },
        { label: 'Base Currency symbol', name: 'base_currancy_symbol', type: 'text', isRequired: false },
        { label: 'Formal name', name: 'formal_name', type: 'text', isRequired: false },
        { label: 'Suffix symbol to amount', name: 'suffex_symbol_amount', type: 'text', isRequired: false },
        {
            label: 'Add space between amount and symbol', name: 'add_space_between_amount_symbol', type: 'text', isRequired: false, isDrop: true,
            state: drop_add_show,
            setState: setDrop_add_show
            // state: drop['add_space_between_amount_symbol'],
            // setState: (val) => setDrop((prevDrop) => ({
            //     ...prevDrop,
            //     ['add_space_between_amount_symbol']: val,
            // }))
        },
        { label: 'Number of decimal places', name: 'no_of_decimal_place', type: 'text', isRequired: false },
        { label: 'Word representing amount after decimal', name: 'word_reprenting_after_amount', type: 'text', isRequired: false },
        { label: 'Number of decimal places for amount in words', name: 'no_of_decimal_place_for_amount', type: 'text', isRequired: false },
    ];



    const handleClickOutside = (event) => {
        if (nameInput.current) {
            event.preventDefault();
            nameInput.current.focus();
        }
    };

    const handleClickInside = (event) => {
        let clickedElement = event.target;
        if (clickedElement?.tagName &&
            (clickedElement?.tagName.toLowerCase() === 'input' ||
                clickedElement?.tagName.toLowerCase() === 'textarea')) {
            clickedElement.focus();
        }
    };

    useClickOutside(nameInput, handleClickOutside, handleClickInside);

    return (
        <div className='container-fluid'>
            {
                submitConfirm === 'Accept' ?
                    <CreateConfirm
                        message={submitConfirm}
                        handleSubmit={handleSubmit}
                        handleFocusReset={handleFocusReset}
                    /> : null
            }
            <ToastContainer />
            {
                loading ? (
                    <Indicator />
                ) : (
                    <div className='row' style={{ pointerEvents: submitConfirm === 'Accept' ? 'none' : 'auto' }}>
                        <div className='col-12'>
                            <div className='row table_date_header'>
                                <div className='col m-0 p-0  table_header_font'>
                                    <b>Company Creation </b>
                                </div>
                            </div>
                            <form className='m-0 p-0' method='POST' autoComplete='off' target="_self" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                                <div className='row position-relative'>
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col-sm-6 ps-1'>
                                                {inputFields.slice(0, 2).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                                {inputFields.slice(2, 3).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <TextArea
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                            </div>
                                            <div className='col-sm-6 ps-1'>
                                                {inputFields.slice(3, 8).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                            </div>
                                            <div className='col-sm-6 ps-1'>
                                                {inputFields.slice(8, 13).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                                {
                                                    showStateList ?
                                                        <DropdownLayout_1
                                                            title='List of State'
                                                            state={showStateList}
                                                            setState={setShowStateList}
                                                            data={data}
                                                            setData={setData}
                                                            input_value={data?.state}
                                                            input_key='state'
                                                            rawData={statesList}
                                                            ref={inputRefs.state}
                                                            refs={refs}
                                                        /> : null}
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-6 ps-1 pb-1'>
                                                {inputFields.slice(13, 17).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                        <div className='row border-top'>
                                            <div className='col-sm-6 ps-1 pt-1'>
                                                {inputFields.slice(17, 20).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                                {inputFields.slice(20, 21).map(({ label, name, type, value, ref, isRequired, isDrop, state, setState }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                        show_drop={state}
                                                        setDrop_add_show={setState}
                                                        data={data}
                                                        setData={setData}
                                                        refs={refs}
                                                        isDrop={isDrop}
                                                    />
                                                ))}



                                            </div>
                                            <div className='col-sm-6 ps-1 pt-1'>
                                                {inputFields.slice(21).map(({ label, name, type, value, ref, isRequired }) => (
                                                    <InputField
                                                        key={name}
                                                        lable={label}
                                                        type={type}
                                                        name={name}
                                                        value={data[name] || ''}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        handleFocus={handleFocus}
                                                        handleKeyDown={handleKeyDown}
                                                        isRequired={isRequired}
                                                        ref={inputRefs[name]}
                                                    />
                                                ))}
                                            </div>

                                        </div>
                                    </div>
                                </div >
                                <RegistrationFooter />
                            </form>
                        </div>
                    </div>
                )}
        </div >
    )
}
export default RegistrationPage